module.exports = __webpack_public_path__ + "static/media/s_bobsled.5c61d585.mp3";